import { useMemo } from 'react';

import { mean } from 'lodash-es';

import type { TrackingProperties } from '@change-corgi/tracking-properties';

import { usePromotePageData } from 'src/app/pages/promote/pageContext';
import { useTrackView } from 'src/app/shared/hooks/tracking';

export function useHeroFeedView(): void {
	const {
		data: {
			petition: {
				feeds: { heroFeed },
			},
		},
	} = usePromotePageData();

	const eventData = useMemo((): TrackingProperties => {
		const promotionAmounts = heroFeed.map((item) =>
			item.event.__typename === 'HeroFeedPromotionEvent' ? item.event.amountUsd : 0,
		);

		return {
			promote_feed_displayed: true,
			promote_feed_item_count: heroFeed.length,
			promote_feed_photo_count: heroFeed.filter((item) => !!item.userPhoto).length,
			promote_feed_amounts_usd: promotionAmounts,
			promote_feed_amounts_usd_mean: mean(promotionAmounts),
		};
	}, [heroFeed]);

	useTrackView('pp_feed_treated', eventData);
}
